/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiAuthPayloadFromJSON(json) {
    return ApiAuthPayloadFromJSONTyped(json, false);
}
export function ApiAuthPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'linkAccountProjectId': !exists(json, 'linkAccountProjectId') ? undefined : json['linkAccountProjectId'],
        'oauthClientId': !exists(json, 'oauthClientId') ? undefined : json['oauthClientId'],
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
        'shop': !exists(json, 'shop') ? undefined : json['shop'],
    };
}
export function ApiAuthPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'linkAccountProjectId': value.linkAccountProjectId,
        'oauthClientId': value.oauthClientId,
        'redirectUrl': value.redirectUrl,
        'shop': value.shop,
    };
}
